import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import ReceiptScanner from './pages/receipt-scanner';
import BillOverview from './pages/bill-overview';
import PaymentSummary from './pages/payment-summary';
import SessionManagement from './pages/session-management';
import ItemSelectionPage from './pages/item-selection';
import JoinSession from './pages/JoinSession';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<ReceiptScanner />} />
        <Route path="/receipt-scanner" element={<ReceiptScanner />} />
        <Route path="/qr-code-scanner" element={<ReceiptScanner />} /> {/* Backward compatibility */}
        <Route path="/join/:sessionId" element={<JoinSession />} />
        <Route path="/bill-overview" element={<BillOverview />} />
        <Route path="/payment-summary" element={<PaymentSummary />} />
        <Route path="/session-management" element={<SessionManagement />} />
        <Route path="/item-selection" element={<ItemSelectionPage />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
